const accordionItems = document.querySelectorAll(".sm_accordion-item");

accordionItems.forEach((item) => {
  const title = item.querySelector(".sm_accordion-title");
  const content = item.querySelector(".sm_accordion-content");

  title.addEventListener("click", () => {
    item.classList.toggle("active");
    if (item.classList.contains("active")) {
      content.style.minHeight = content.scrollHeight + "px";
    } else {
      content.style.minHeight = "0";
    }
  });
});
